var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export function chunks(array, size) {
    return Array.apply(0, new Array(Math.ceil(array.length / size))).map((_, index) => array.slice(index * size, (index + 1) * size));
}
export const getMultipleAccounts = (connection, keys, onGetMultipleAccountsError, commitment = "recent") => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield Promise.all(chunks(keys, 99).map((chunk) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            return yield getMultipleAccountsCore(connection, chunk, commitment);
        }
        catch (e) {
            const error = new SolanaGetMultipleAccountsError(chunk, commitment, e);
            onGetMultipleAccountsError === null || onGetMultipleAccountsError === void 0 ? void 0 : onGetMultipleAccountsError(error);
            return {
                keys: chunk,
                error,
            };
        }
    })));
    const array = result
        .map((el) => {
        if ("error" in el) {
            return el.keys.map(() => el.error);
        }
        return el.array.map((acc) => {
            if (!acc) {
                return null;
            }
            const { data } = acc, rest = __rest(acc, ["data"]);
            const dataStr = data === null || data === void 0 ? void 0 : data[0];
            return Object.assign(Object.assign({}, rest), { data: dataStr ? Buffer.from(dataStr, "base64") : Buffer.alloc(0) });
        });
    })
        .flat();
    return { keys, array };
});
const getMultipleAccountsCore = (conn, keys, commitment = "recent") => __awaiter(void 0, void 0, void 0, function* () {
    const connection = conn;
    const stringKeys = keys.map((k) => k.toString());
    const args = connection._buildArgs([stringKeys], commitment, "base64");
    const unsafeRes = yield connection._rpcRequest("getMultipleAccounts", args);
    if (unsafeRes.error) {
        throw new Error("failed to get info about account " + unsafeRes.error.message);
    }
    if (unsafeRes.result.value) {
        const array = unsafeRes.result.value;
        return { keys, array };
    }
    throw new Error("getMultipleAccountsCore could not get info");
});
export class SolanaGetMultipleAccountsError extends Error {
    constructor(keys, commitment, originalError) {
        super(`Error fetching accounts: ${originalError.message}`);
        this.keys = keys;
        this.commitment = commitment;
        this.originalError = originalError;
        this.name = "SolanaGetMultipleAccountsError";
    }
}
//# sourceMappingURL=fetchers.js.map